<template>
	<vxe-modal v-model="listParamModalShow" width="800" height="700" :title="title" show-footer destroy-on-close
		@show="show" @hide="hide" transfer :lock-scroll="false">

		<template #default>
			<el-form ref="form" :model="listParamForm" label-width="60px" size="mini">
				<el-form-item label="基础">
					<el-checkbox @change="listParamFormChange" label="show" v-model="listParamForm.show">列表显示
					</el-checkbox>
					<el-checkbox @change="listParamFormChange" label="search" v-model="listParamForm.search">普通搜索
					</el-checkbox>
					<el-checkbox @change="listParamFormChange" label="search" v-model="listParamForm.defaultshow">默认显示
					</el-checkbox>
					<el-checkbox @change="listParamFormChange" label="importsearch" v-model="listParamForm.importsearch"
						v-if="itemtype=='varchar'">导入搜索
					</el-checkbox>
					<el-checkbox @change="listParamFormChange" label="penetrate" v-model="listParamForm.penetrate">穿透
					</el-checkbox>
					<el-checkbox @change="listParamFormChange" label="sortable" v-model="listParamForm.sortable">排序
					</el-checkbox>
					<el-checkbox @change="listParamFormChange" label="copycontent"
						v-model="listParamForm.copycontent">复制
					</el-checkbox>
					<el-checkbox @change="listParamFormChange" label="statistics" v-model="listParamForm.statistics">统计
					</el-checkbox>
				</el-form-item>
				<el-form-item label="类型">
					<el-radio @change="listParamFormChange" label="" v-model="listParamForm.fieldtype">普通</el-radio>
					<el-radio @change="listParamFormChange" label="radio" v-model="listParamForm.fieldtype">单选框
					</el-radio>
					<el-radio @change="listParamFormChange" label="checkbox" v-model="listParamForm.fieldtype">复选框
					</el-radio>
					<el-radio @change="listParamFormChange" label="treeNode" v-model="listParamForm.fieldtype">树节点
					</el-radio>
					<el-radio @change="listParamFormChange" label="html" v-model="listParamForm.fieldtype">html
					</el-radio>
				</el-form-item>
				<el-form-item label="固定">
					<el-radio @change="listParamFormChange" :label="false" v-model="listParamForm.fixed">不固定</el-radio>
					<el-radio @change="listParamFormChange" label="left" v-model="listParamForm.fixed">左固定</el-radio>
					<el-radio @change="listParamFormChange" label="right" v-model="listParamForm.fixed">右固定</el-radio>
				</el-form-item>
				<el-form-item label="统计模块" v-if="listParamForm.statistics">
					<el-input @change="listParamFormChange" v-model="listParamForm.statisticsmodel"></el-input>
				</el-form-item>
				<el-form-item label="格式">
					<el-select v-model="listParamForm.formatter" @change="listParamFormChange" filterable allow-create
						default-first-option clearable>
						<el-option label="staff" value="staff"></el-option>
						<el-option label="department" value="department"></el-option>
						<el-option label="datetime" value="datetime"></el-option>
						<el-option label="date" value="date"></el-option>
						<el-option label="file" value="file"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="宽度">
					<el-input-number @change="listParamFormChange" v-model="listParamForm.width" :min="50">
					</el-input-number>
				</el-form-item>
				<el-form-item label="序号">
					<el-input-number @change="listParamFormChange" v-model="listParamForm.order" :min="1">
					</el-input-number>
				</el-form-item>
				<el-form-item label="" label-width="0">
					<vJsoneditor v-model="listParamFormJson" height="300px" :options="{mode:'code'}" />
				</el-form-item>
			</el-form>
		</template>


		<template #footer>
			<vxe-button status="" content="取消" @click="listParamModalShow=false"></vxe-button>
			<vxe-button status="primary" content="确定" @click="listParamSubmit"></vxe-button>
		</template>
	</vxe-modal>
</template>
<script>
	import vJsoneditor from 'v-jsoneditor'
	export default {
		props: {
			title: {
				default: () => {
					return '列表字段配置'
				}
			},
			config: {
				default: () => {
					return {}
				}
			},
			itemtype: {
				default: () => {
					return ''
				}
			},


		},
		data() {
			return {
				listParamModalShow: false,
				listParamForm: {},
				listParamFormJson: {}
			}
		},
		created() {


		},
		mounted() {


		},
		watch: {

		},
		computed: {

		},

		methods: {
			show() {
				let listParamForm = {}
				for (let i in this.config) {
					listParamForm[i] = this.config[i]
				}
				this.listParamForm = listParamForm
				this.listParamFormJson = this.config
			},
			hide() {
				this.listParamFormJson = {}
				this.listParamForm = {
					show: false,
					search: false,
					defaultshow: false,
					importsearch: false,
					penetrate: false,
					sortable: false,
					copycontent: false,
					statistics: false,
					fixed: false,
					order: 100,
					width: 100,
				}
			},
			listParamFormChange() {
				this.listParamFormJson = JSON.parse(JSON.stringify(this.listParamForm))
				//console.log(this.listParamForm)
			},
			modal_show() {
				this.listParamModalShow = true
			},
			listParamSubmit() {
				this.$emit('submit', this.listParamFormJson)
				this.listParamModalShow = false
			}
		},
		components: {
			vJsoneditor
		}
	}
</script>